export default class Constants {

    static get ALL_CITIES() {
        return [
            "ugljevik",
            "gacko"
        ];
    }

    static get ALL_CITIES_FOR_DROPDOWN() {
        return this.ALL_CITIES.map((city) => {
            const text = city.charAt(0).toUpperCase() + city.slice(1);
            return { key: city, text, value: city };
        });
    }

    static get ALL_POLLUTANTS() {
        return [
            "SOx",
            "NOx",
            "NMVOC",
            "CO",
            "PM10",
            "PM2.5",
            "PM_TSP",
            "N2O",
            "Cd",
            "Pb",
            "Hg",
            "PAU",
            "PCDD/F",
            "PCB",
            "HCB",
            "NH3",
            "C6H6"
        ];
    }

    static get ALL_SECTORS_FOR_DROPDOWN() {
        return [
            {
                key: "Ukupno",
                text: "Ukupno",
                value: "ukupno",
            },
            {
                key: "NFR 1.A.1 Energetska postrojenja",
                text: "NFR 1.A.1 Energetska postrojenja",
                value: "energetskapostrojenja",
            },
            {
                key: "NFR 1.A.3 Saobraćaj",
                text: "NFR 1.A.3 Saobraćaj",
                value: "saobracaj",
            },
            {
                key: "NFR 1.A.4 Mala ložišta",
                text: "NFR 1.A.4 Mala ložišta",
                value: "malalozista",
            },
            {
                key: "NFR 2.A.5.a Kamenolom i iskopavanje minerala osim uglja",
                text: "NFR 2.A.5.a Kamenolom i iskopavanje minerala osim uglja",
                value: "kamenolomiiskopavanjemineralaosimuglja",
            },
            {
                key: "NFR 1.B.1.a Pridobivanje i rukovanje ugljem",
                text: "NFR 1.B.1.a Pridobivanje i rukovanje ugljem",
                value: "pridobivanjeirukovanjeugljem",
            },
            {
                key: "NFR 3.D Proizvodnja usjeva i poljoprivrednih tala",
                text: "NFR 3.D Proizvodnja usjeva i poljoprivrednih tala",
                value: "prozivodnjausjevaipoljoprivrednihtala",
            }
        ];
    }
}